wbApp.controller('ContractsCtrl', ['$scope', '$modal', '$translate', '$filter', '$timeout', '$q', 'contractSvc', 'groupSvc', 'securitySvc',
function ($scope, $modal, $translate, $filter, $timeout, $q, contractSvc, groupSvc, securitySvc) {

    $scope.contractsRaw = [];
    $scope.contracts = [];
    $scope.groups = groupSvc.getAllAsync();
    $scope.customFilter = { groups: [] };
    
    function preFilter() {
        return $q(function (resolve, reject) {
            $q.all([$scope.contractsRaw.$promise, $scope.groups.$promise]).then(function () {
                var groupIDs = _.values($scope.customFilter.groups);
                $scope.contracts.length = 0;
                $scope.contracts.push.apply($scope.contracts,
                    _.filter($scope.contractsRaw, function (o) {
                        if (groupIDs.length > 0) {
                            return _.intersectionWith(o.studentGroupsIds, groupIDs, function(g1, g2) {
                                return g1 == g2;
                            }).length > 0;
                        }
                        return true;
                    })
                );
                resolve();
            });
        });
    }    
    
    function refreshData(reselect)
    {
        return $q(function (resolve, reject) {
            var selectedRowKeys = null;
            if (!!$scope.gridSettings && !!$scope.gridSettings.gridInstance && !!reselect) {
                selectedRowKeys = $scope.gridSettings.gridInstance.getSelectedRowKeys();
            }

            let all = contractSvc.getAll(true);
            all.$promise.then(function (data) {
                $scope.contractsRaw = data;
                preFilter().then(function() {
                    if (!!selectedRowKeys && !!$scope.gridSettings && !!$scope.gridSettings.gridInstance && !!reselect) {
                        $timeout(function () {
                            $scope.gridSettings.gridInstance.selectRows(selectedRowKeys, false).then(function (rows) {
                                if (!rows || !rows.length) {
                                    setSelectedContract(null);
                                }
                            })
                        }, 100);
                    }
                    else {
                        setSelectedContract(null);
                    }

                    resolve();
                });
            }, function (error) {
                $scope.contracts = [];
                setSelectedContract(null);

                reject();
            });
        });
    }

    refreshData();

    $scope.$on('refreshData', function (e, data) {
        refreshData(true);
    });

    $scope.$watch('customFilter', function (newValue, oldValue) {
        preFilter();
    }, true);

    $scope.onRowSelected = function (data) {
        setSelectedContract(data);
    }

    let onPrintContractByType = function (model, contractTemplateType) {
        window.open("restapi/contracts/" + model.id + "/report/" + contractTemplateType, '_blank');
    }

    $scope.gridSettings = {
        name: 'contracts',
        keyExpr: 'id',
        shouldShowColumnChooser: true,
        columns: [
            { dataField: 'id', caption: $translate.instant('TXT_LBL_ID'), dataType: 'string', visible: false },
            { dataField: 'isActive', caption: $translate.instant('TXT_LBL_ACTIVE'), dataType: 'boolean', width: '60px' },
            { dataField: 'fromDate', caption: $translate.instant('TXT_LAB_VALID_FROM'), dataType: 'date', format: { type: 'shortDate' }, width: '80px' },
            { dataField: 'toDate', caption: $translate.instant('TXT_LAB_VALID_TO'), dataType: 'date', format: { type: 'shortDate' }, width: '80px' },
            {
                dataField: 'studentSurname',
                caption: $translate.instant('TXT_LBL_STUDENT'),
                dataType: 'string',
                width: '140px',
                calculateCellValue: function (rowData) {
                    return String.prototype.fullName(rowData.studentName, rowData.studentMiddleName, rowData.studentSurname);
                }
            },
            {
                dataField: 'userSurname',
                caption: $translate.instant('TXT_LBL_PARENT'),
                dataType: 'string',
                width: '140px',
                calculateCellValue: function (rowData) {
                    return String.prototype.fullName(rowData.userName, rowData.userMiddlename, rowData.userSurname);
                }
            },           
            {
                dataField: 'contractSchedules',
                caption: $translate.instant('TXT_SCHEDULE'),
                dataType: 'string',
                calculateCellValue: function (rowData) {
                    return $filter('contractScheduleShort')(rowData.contractSchedules);
                }
            },
            {
                dataField: 'studentGroupsIds',
                caption: $translate.instant('TXT_MENU_GROUPS'),
                dataType: 'string',
                encodeHtml: false,
                allowFiltering: false,
                allowHeaderFiltering: false,
                calculateCellValue: function (rowData) {
                    return $filter('groupsColors')(rowData.studentGroupsIds);
                },
                width: '80px'
            },            
            {
                dataField: 'accountingBookId',
                caption: $translate.instant('TXT_LBL_ACCOUNTING_BOOK'),
                dataType: 'string',
                calculateCellValue: function (rowData) {
                    return $filter('accountingBook')(+rowData.accountingBookId);
                },
                width: '180px',
                visible: false
            },           
        ],
        customCommands: [{
            text: $translate.instant('TXT_MENU_PRINT_CONTRACT'),
            isVisible: function (data) { return securitySvc.isInRole('Reports') && !!contractSvc.getContractTemplateIdByType(data, 0); },
            callback: function (data) { onPrintContractByType(data, 0); }            
        },{
            text: $translate.instant('TXT_MENU_PRINT_DOCTORS_ASSESSMENT'),
            isVisible: function (data) { return securitySvc.isInRole('Reports') && !!contractSvc.getContractTemplateIdByType(data, 1); },
            callback: function (data) { onPrintContractByType(data, 1); }
        },{
            text: $translate.instant('TXT_MENU_PRINT_REGISTRATION_SHEET'),
            isVisible: function (data) { return securitySvc.isInRole('Reports') && !!contractSvc.getContractTemplateIdByType(data, 2); },
            callback: function (data) { onPrintContractByType(data, 2); }
        },{
            text: $translate.instant('TXT_MENU_PRINT_LABOR_MARKET_POSITION'),
            isVisible: function (data) { return securitySvc.isInRole('Reports') && !!contractSvc.getContractTemplateIdByType(data, 3); },
            callback: function (data) { onPrintContractByType(data, 3); }
        },{
            text: $translate.instant('TXT_MENU_PRINT_GDPR'),
            isVisible: function (data) { return securitySvc.isInRole('Reports') && !!contractSvc.getContractTemplateIdByType(data, 4); },
            callback: function (data) { onPrintContractByType(data, 4); }
        },{
            text: $translate.instant('TXT_MENU_PRINT_CUSTOM_1'),
            isVisible: function (data) { return securitySvc.isInRole('Reports') && !!contractSvc.getContractTemplateIdByType(data, 6); },
            callback: function (data) { onPrintContractByType(data, 6); }
        },{
            text: $translate.instant('TXT_MENU_PRINT_CUSTOM_2'),
            isVisible: function (data) { return securitySvc.isInRole('Reports') && !!contractSvc.getContractTemplateIdByType(data, 7); },
            callback: function (data) { onPrintContractByType(data, 7); }
        },{
            text: $translate.instant('TXT_SEND_CONTRACTS'),
            isVisible: function (data) { return !!data.contractTemplatesInfos },            
            callback: function (data) { onShowSendContractsParamsDialog(data); },
            beginGroup: true
        },{
            text: $translate.instant('TXT_OPZ_PLUS'),
            isVisible: function (data) { return securitySvc.isInRole('Reports') },
            callback: function (data) { onShowOpzPlusParamsDialog(); },
            beginGroup: true
        }]
    }

    $scope.onRowAdd = function () {
        detailDialogPromise.$promise.then(function () {
            contractSvc.createNew().then(function(newModel) {
                detailDialogPromise.$scope.model = newModel;
                detailDialogPromise.$scope.onContractSave = function (model) {
                    refreshData().then(function () {
                        if (!!$scope.gridSettings && !!$scope.gridSettings.gridInstance) {
                            $timeout(function () {
                                $scope.gridSettings.gridInstance.selectRows([model.id], false).then(function (rows) {
                                    if (!rows || !rows.length) {
                                        setSelectedContract(null);
                                    }
                                });
                            }, 100);
                        }
                    });
                };
                detailDialogPromise.show();
            });
        });
    }

    $scope.onRowEdit = function (data) {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = angular.copy(data);
            detailDialogPromise.$scope.onContractSave = function () {
                refreshData(true);
            };
            detailDialogPromise.show();
        });
    }

    $scope.onRowDelete = function (data) {
        contractSvc.remove(data.id).$promise.then(function () {
            refreshData();
        });
    }    

    $scope.onRowCopy = function (data) {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = angular.copy(data);
            detailDialogPromise.$scope.model.isNew = true;
            detailDialogPromise.$scope.model.id = null;
            detailDialogPromise.$scope.onContractSave = function (model) {
                refreshData().then(function () {
                    if (!!$scope.gridSettings && !!$scope.gridSettings.gridInstance) {
                        $timeout(function () {
                            $scope.gridSettings.gridInstance.selectRows([model.id], false).then(function (rows) {
                                if (!rows || !rows.length) {
                                    setSelectedContract(null);
                                }
                            });
                        }, 100);
                    }
                });
            };
            detailDialogPromise.show();
        });
    }
    
    function onShowSendContractsParamsDialog(contract) {
        sendContractsParamsDialogPromise.$promise.then(function () {
            sendContractsParamsDialogPromise.$scope.contract = angular.copy(contract);
            // sendContractsParamsDialogPromise.$scope.onContractsSend = function () {
            // };
            sendContractsParamsDialogPromise.show();
        });       
    }
    
    function  onShowOpzPlusParamsDialog() {
        opzPlusParamsDialogPromise.$promise.then(function() {
            opzPlusParamsDialogPromise.show();
        });
    }
    
    function setSelectedContract(contract, refresh) {
        $scope.selectedContract = contract;
        $scope.$broadcast('contractSelectionChanged', $scope.selectedContract);
    }

    var detailDialogPromise = $modal({
        templateUrl: 'activities/contracts/contract-detail.html',
        show: false,
        scope: $scope.$new()
    });

    var sendContractsParamsDialogPromise = $modal({
        templateUrl: 'activities/contracts/send-contracts-params-dialog.html',
        show: false,
        scope: $scope.$new()
    });

    var opzPlusParamsDialogPromise = $modal({
        templateUrl: 'activities/contracts/opz-plus-params-dialog.html',
        show: false,
        scope: $scope.$new()
    });

}]);
